module.exports = __webpack_public_path__ + "img/simulacion.0d1601f7.png";